module.exports = __webpack_public_path__ + "static/media/thegrguide-IG.e5b5b176.PNG";